module.exports = __webpack_public_path__ + "img/logo-emilla.9fc259ac.png";